import { styled } from "@mui/material/styles";

import { Markdown } from "@/features/shared/widgets";

/*
    Styles are copied from _compontents.page-title.scss from old source code (source-exons-client)
    NOTE: this is not a good practice, but it's a quick solution to migrate the old code to new one
*/
const StyledHeader = styled("h1")`
  font-size: 2.5rem;
  margin-top: 0;
`;

const PageTitle = ({ title, description }: { title: string; description: string }) => {
  return (
    <div>
      <StyledHeader>{title}</StyledHeader>
      <Markdown content={description} />
    </div>
  );
};

export default PageTitle;
